<template>
	<div v-loading.fullscreen.lock="loadingSave" :element-loading-text="'Aguarde enquanto o upload é processado...'+(requestParam.uploadProgress != null ? '\n'+requestParam.uploadProgress+'%' : '')">

		<!--FILTRO AVANÇADO -->
		<UploadPagina :parent="this"/>
		<ed-modal
			title="UPLOAD DE ASO"
			:modal="parent.showUploadASO"
			:loadingSave="loadingSave"
			:onSave="salvar"
			width="98%"
			saveName="Salvar"
		>
			<div slot="modal-content">
				<el-tabs type="border-card" v-model="tagConfig" @tab-click="handleClick">

					<el-tab-pane label="Config" name="tab-cadastro">
						<span slot="label"><i class="fa fa-upload"></i> Fazer Novo Upload</span>

						<el-alert
							v-if="formData.tipo == 86"
							title="Atenção"
							type="warning"
							description="Na Identificação Automática o sistema reconhece automaticamente a quem pertence o ASO. Para isso funcionar verifique se o ASO está em PDF e possui no rodapé o código de identificação."
							show-icon>
						</el-alert>

						<el-alert
							v-else-if="formData.tipo == 87"
							title="Atenção"
							type="warning"
							description="Na Identificação Manual o sistema exige que você informe a quem pertence o ASO: empresa, funcionário e a consulta."
							show-icon>
						</el-alert>

						<el-form label-position="top" label-width="100px" :model="formData" ref="ruleForm">

							<div class="col-md-12">
									<el-form-item label="Escolha o Tipo do Upload"
										prop="tipo"
										:rules="[
											{ required: true, message: 'Campo Obrigatorio'},
										]"
									>
										<el-select
											v-model="formData.tipo"
										>
											<el-option
												v-for="item in lstTipoUpload"
												:key="item.id"
												:value="item.id"
												:label="item.descricao"
											>
											</el-option>
										</el-select>
									</el-form-item>
							</div>

							<div class="col-md-12">

								<el-form-item label="Selecione o ASO (no formato PDF e no máximo 25MB de tamanho)"
									prop="arquivo"
									:rules="[
											{ required: true, message: 'Campo Obrigatorio'},
									]"
									:class="error['arquivo'] ? 'is-error' : ''"
									>
									<Upload :onChangeFile="handleArquivo" :currentFile="formData.arquivo" ordem="1"></Upload>
									<div v-if="error['arquivo']" class="el-form-item__error">{{error['arquivo'][0]}}</div>

								</el-form-item>
							</div>

							<div class="col-md-12">
									<el-form-item label="Escolha o Tipo do Documento"
										prop="documento"
										:rules="[
											{ required: true, message: 'Campo Obrigatorio'},
										]"
									>
										<span slot="label">
											Escolha o Tipo do Documento
											<el-tooltip
												v-if="formData.documento == 83"
												class="item"
												effect="dark"
												content="Certifique-se que a primeira página do Prontuário Médico esteja anexado a FEMO da consulta ( Ficha de Exame Médico Ocupacional)"
												placement="top"
											>
												<a href="#">
													<i class="fa fa-question-circle" aria-hidden="true"/>
												</a>
											</el-tooltip>
										</span>

										<el-select
											v-model="formData.documento"
											:disabled="formData.tipo == 86"
										>
											<el-option
												v-for="item in lstTipoDocumento"
												:key="item.id"
												:value="item.id"
												:label="item.descricao"
											>
											</el-option>
										</el-select>

									</el-form-item>
							</div>

							<div class="col-md-12">
								<el-form-item label="Empresa"
									prop="id_emp"
									:rules="[
										{ required: (formData.tipo == 87), message: 'Campo Obrigatorio'},
									]"
								>
									<el-select
										v-model="formData.id_emp"
										filterable
										remote
										clearable
										placeholder="Digite o nome da empresa"
										:remote-method="getEmpresa"
										:loading="loadingEmpresa"
										:disabled="formData.tipo == 86"
										@change="getFuncionario"
									>
										<el-option
											v-for="item in lstEmpresa"
											:key="item.id"
											:value="item.id"
											:label="item.nome"
										>
											<div style="float: left">
												<b>{{ item.nome }}</b>
											</div>
											<div style="float: right; color: #8492a6; font-size: 13px">
													{{item.cnpj}}
											</div>
										</el-option>
									</el-select>

								</el-form-item>
							</div>

							<div class="col-md-12">
								<el-form-item label="Funcionario"
									prop="id_fun"
									:rules="[
										{ required: (formData.tipo == '87'), message: 'Campo Obrigatorio'},
									]"
								>
									<el-select
										v-model="formData.id_fun"
										filterable
										remote
										clearable
										placeholder="Digite o nome do funcionário"
										:remote-method="getFuncionario"
										:loading="loadingFuncionario"
										:disabled="!formData.id_emp"
										@change="getConsulta"
									>
										<el-option
											v-for="item in lstFuncionario"
											:key="item.id"
											:value="item.id"
											:label="item.nome"
										>
											<div style="float: left">
												<b>{{ item.nome }}</b>
											</div>
											<div style="float: right; color: #8492a6; font-size: 13px">
													{{item.cnpj}}
											</div>
										</el-option>
									</el-select>

								</el-form-item>
							</div>

							<div class="col-md-12">
								<el-form-item label="Consulta"
									prop="id_con"
									:rules="[
										{ required: (formData.tipo == '87'), message: 'Campo Obrigatorio'},
									]"
								>
									<el-select
										v-model="formData.id_con"
										clearable
										placeholder="Selecione a consulta"
										:loading="loadingConsulta"
										:disabled="!formData.id_fun"
									>
										<el-option
											v-for="item in lstConsulta"
											:key="item.id_con"
											:value="item.id_con"
											:label="item.id_con+((item.dt_cad ? ' | '+toDate(item.dt_cad,true) : '')+(item.tipo_aso ? ' | '+item.tipo_aso.descricao : ''))"
										>
											<div style="float: left">
												{{item.id_con}} | {{(item.dt_cad ? toDate(item.dt_cad,true) : '')}} | {{(item.tipo_aso ? item.tipo_aso.descricao : '')}}
											</div>
										</el-option>
									</el-select>

								</el-form-item>
							</div>

							<div class="col-md-12" v-if="formData.documento == 83">
									<el-form-item label="Juntar Arquivo"
										prop="juntar"
										:rules="[
											{ required: true, message: 'Campo Obrigatorio'},
										]"
									>
										<span slot="label">
											Juntar Arquivo
											<el-tooltip
												v-if="formData.documento == 83"
												class="item"
												effect="dark"
												content="Se essa opção estiver marcado, o sistema vai adicionar esse upload nos os arquivos enviados anteriormente."
												placement="top"
											>
												<a href="#">
													<i class="fa fa-question-circle" aria-hidden="true"/>
												</a>
											</el-tooltip>
										</span>

										<el-switch
											v-model="formData.juntar"
											:active-value="1"
											:inactive-value="0"
										>
										</el-switch>

									</el-form-item>
							</div>


						</el-form>

					</el-tab-pane>

					<el-tab-pane label="Config" name="tab-historico">
						<span slot="label">
							<i :class="'fa fa-history'+(novaLiberacao ? ' faa-flash animated' : '')"></i>
							Histórico de Uploads
						</span>

						<TableView
							:onSearch="getConsultaUpload"
							:onDelete="onDelete"
							:tableHead="tableHead"
							:tableData="tableData"
							:loadingTable="loadingTable"
							:loadingEditAll="loadingEditAll"
							:pagination="pagination"
						/>

					</el-tab-pane>
				</el-tabs>
			</div>
		</ed-modal>


	</div>
</template>

<script>

	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Fct from 'common/fct'
	import EdModal from 'common/modal'
	import Upload from 'common/upload'
	import UploadPagina from './upload-pagina-aso'

  	export default {
  		name:"empresa",
  		components: {TableView,Upload,UploadPagina,EdModal},
		mixins:[Rest,Upload,Fct],
		props:{
			parent:{
				type:Object,
				default:null
			},
		},
		watch:{
			'parent.showUploadASO'(){
				this.getConsultaUpload();
				this.tagConfig = 'tab-cadastro';

				this.formData = {
					tipo:86,
					documento:82,
					juntar:1,
					id_emp:null,
					id_fun:null,
					id_con:null,
					arquivo:null
				};
			},
		},
  		data () {
		   	return {
		   		formData:{
					tipo:86,
					documento:82,
					juntar:1,
					id_emp:null,
					id_fun:null,
					id_con:null,
					arquivo:null
				},
				pagination:{},
				error:{},
				upload_pagina:null,
		   		tableHead:[
					{
		                key: 'data',
						sortable: true,
						width:'120px',
						label: 'Data',
					},
					{
		                key: 'usuario',
						sortable: true,
						label: 'Usuário',
					},
					{
		                key: 'lote',
						sortable: true,
						width:'55px',
						label: 'Lote',
					},
					{
		                key: 'arquivo',
						sortable: true,
						show_arquivo:true,
						label: 'Arquivo',
					},
					{
		                key: 'tipo',
						sortable: true,
						label: 'Tipo',
					},
					{
		                key: 'status',
						sortable: true,
						show_status:true,
						label: 'Status',
					},

		   		],
				tableData:[],
				lstTipoStatus:[],
				lstTipoDocumento:[],
				lstTipoUpload:[],
				lstEmpresa:[],
				lstFuncionario:[],
				lstConsulta:[],
				loadingFuncionario:false,
				loadingConsulta:false,
				loadingEmpresa:false,
				loadingEditAll:false,
				loadingTable:false,
				loadingSave:false,
				showUploadPagina:false,
				novaLiberacao:false,
				tagConfig:'tab-cadastro',
				title: ''

			}
		},

		created(){
		},

		mounted: function() {
			this.getEmpresa();
			this.getTipo()
			this.getConsultaUpload();

			this.$events.on('onClienteEvent', eventData => {
				this.getConsultaUpload();
	        });
		},

		methods: {

			handleClick(tab, event) {
				this.novaLiberacao = false;
			},

			handleAptidao(){
				if(this.formData.aptidao == 2){
					this.formData.id_tipo_status = 67;
				}

				if(this.formData.aptidao == 5){
					this.formData.te_alt = 0;
					this.formData.te_esp = 0;
					this.formData.te_ele = 0;
          this.formData.te_ali = 0;
					this.formData.id_tipo_status = 70;
				}
			},

			handleArquivo(e){
                e.preventDefault();
                this.formData.arquivo = e.target.files[0];
			},

			onUploadPagina: function(data){
				this.upload_pagina = data;
				this.showUploadPagina = !this.showUploadPagina;
			},

			onUploadEditar: function(data){

				var self = this;

                this.$confirm('Tem certeza que deseja processar o lote '+data.lote+' novamente?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {


					self.loadingTable = true;

					self.get('/empresa/consulta/upload/editar/'+data.id).then((result)=>{
						result = result[0];

						self.loadingTable = false;

						if(result.status == 200){
							self.getConsultaUpload();
							self.edMsg('Arquivo processado com sucesso. Verifique o status do processamento abaixo.');
						}
						else{
							self.edAlert(result.msg,'error');
						}
					});

				});
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

					self.loadingEditAll = true;
					self.loadingTable = true;

                    this.post('/empresa/consulta/upload/deletar',{ids:data}).then((result)=>{
                        result = result[0];

						self.loadingEditAll = false;
						self.loadingTable = false;

                        if(result.status == 200){

                            this.formataData(result);

							this.$message({
								message: 'Registo excluido com sucesso',
								type: 'success'
							});

                        }
                        else{
                            if(result.status == 403){
                                this.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
                                    confirmButtonText: 'OK'
                                });
                            }
                            else{
                                this.$message({
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    });

                });
			},

			getTipo: function(){

				this.post('tipo/parent',{codigo:[81,85],exclude:[84,88]}).then((result)=>{

		            result = result[0];

		            if(result.status == 200){
						this.lstTipoDocumento = result.data['81'];
						this.lstTipoUpload = result.data['85'];
		            }
		        });
			},

			getEmpresa: function(_search){

                this.loadingEmpresa = true;

                this.get('/empresa',{search:_search}).then((result)=>{

                      result = result[0];

                      if(result.status == 200){
                          this.lstEmpresa = result.data.data;
                      }
                      else{
                          this.lstEmpresa = [];
                      }

                      this.loadingEmpresa = false;

                });

			},

			getFuncionario: function(_search){

				if(!this.formData.id_emp)return;

                this.loadingFuncionario = true;
                this.lstFuncionario = [];

                this.get('/empresa/funcionario/'+this.formData.id_emp,{search:_search}).then((result)=>{

                    result = result[0];

                    this.loadingFuncionario = false;

                    if(result.status == 200){
                      this.lstFuncionario = result.data.data;
                    }
                });

			},

			getConsulta: function(_search){

				if(!this.formData.id_fun || !this.formData.id_emp)return;

                this.loadingConsulta = true;
				this.lstConsulta = [];

				var
					hoje = this.toDate(null,true),
					ontem = this.toDate(this.addDate((-365*2),null,'D'),true),
					amanha = this.toDate(this.addDate(1,null,'D'),true);

				var filter = {
					id_funcionario : this.formData.id_fun,
					id_empresa : this.formData.id_emp,
					created_at : [ontem,amanha]
				};

                this.get('/empresa/consulta',{filter:filter}).then((result)=>{

                    result = result[0];

					this.loadingConsulta = false;

                    if(result.status == 200){
                      this.lstConsulta = result.data.data;
                    }
                });

            },

			getConsultaUpload: function(_search,_page,_pagination){

				this.loadingTable = true;

				this.get('empresa/consulta/upload',{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					 result = result[0];

		             if(result.status == 200){
		             	this.formataData(result);
		             }
		             else{
		             	this.$alert(result.msg, 'Atenção', {
		                    type:'error',
		                    confirmButtonText: 'OK'
		                });
		             }
	            });
			},

			formataData: function(result){

				var
					data = result.data.data,
					tableData = [],
					self = this,
						pagination = result.data

				for (var i = 0; i < data.length; i++) {

					var item = {
						'data': this.toDate(data[i].created_at,false),
						'usuario': (data[i].usuario ? data[i].usuario.usuario : null),
						'tipo': (data[i].tipo_upload ? data[i].tipo_upload.descricao.toUpperCase() : null),
						'lote': data[i].lote,
						'arquivo': data[i].arquivo,
						'status': data[i].obs,
						_data:data[i],
						options:{},
						buttons:[]
					};

					item.buttons.push(
						{
						icon: 'fa fa-files-o',
						color: 'success',
						title: 'Visualizar detalhes das páginas do arquivo',
						click: this.onUploadPagina
						}
					);

					if(data[i].tipo_status && data[i].tipo_status.id == '80'){
						item.buttons.push(
							{
							icon: 'fa fa-cloud-upload',
							color: 'warning',
							title: 'Processar Arquivo Novamente',
							click: this.onUploadEditar
							}
						);
					}

					tableData.push(item);
				}

				this.pagination = pagination;
				this.tableData = tableData;
				this.loadingTable = false;
			},

			salvar: function(){

				this.loadingSave = true;
				this.error = {};

				this.post('empresa/consulta/upload/cadastrar',this.toFormUpload(this.formData)).then((result)=>{

					result = result[0];

					this.loadingSave = false;

					if(result.status == 200){

						this.edMsg('Documento cadastrado com sucesso!');

						this.error = {};
						this.novaLiberacao = true;
						this.tagConfig = 'tab-historico';

						this.formataData(result);
						this.parent.getConsulta();
					}

				});

			}

		}
  	}
</script>



// WEBPACK FOOTER //
// upload-aso.vue?77e0a5c0